import { TypeOf, yup } from '@guiker/shared-framework'

import { PayoutMethodType } from '../../../../entity'

export const payoutMethodTypeSchema = yup.mixed<PayoutMethodType>().oneOf(Object.values(PayoutMethodType)).required()

export type PayoutMethodTypeSchema = TypeOf<typeof payoutMethodTypeSchema>
